import createIcon from '../../createIcon';

/**
 * @component @name RateReview
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkg0QzIuOSAyIDIuMDEgMi45IDIuMDEgNEwyIDIyTDYgMThIMjBDMjEuMSAxOCAyMiAxNy4xIDIyIDE2VjRDMjIgMi45IDIxLjEgMiAyMCAyWk02IDE0VjExLjUzTDEyLjg4IDQuNjVDMTMuMDggNC40NSAxMy4zOSA0LjQ1IDEzLjU5IDQuNjVMMTUuMzYgNi40MkMxNS41NiA2LjYyIDE1LjU2IDYuOTMgMTUuMzYgNy4xM0w4LjQ3IDE0SDZaTTE4IDE0SDEwLjVMMTIuNSAxMkgxOFYxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RateReview = createIcon('RateReview', [
  [
    'path',
    {
      d: 'M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM6 14V11.53L12.88 4.65C13.08 4.45 13.39 4.45 13.59 4.65L15.36 6.42C15.56 6.62 15.56 6.93 15.36 7.13L8.47 14H6ZM18 14H10.5L12.5 12H18V14Z',
      key: '1a02tw',
    },
  ],
]);

export default RateReview;
